import React from 'react';

import { Datagrid, List, ResourceComponentProps, TextField } from 'react-admin';

import { CharacteristicFilter } from '../CharacteristicFilter';

export const CharacteristicList: React.FC<ResourceComponentProps> = props => {
  return (
    <List {...props} actions={false} filters={<CharacteristicFilter />}>
      <Datagrid hasBulkActions={false} isRowSelectable={() => false}>
        <TextField emptyText="-" source="name" />
      </Datagrid>
    </List>
  );
};
